import axios from './util/axios.js'

export function postSubscribeToMarketing ({ email, source }) {
  const headers = {
    'Content-Type': 'application/json'
  }
  return axios.post('/api/marketing/subscribe/', { email, source }, { headers })
}
